<template>
  <div class="voice-image" :style="[positionStyle]" @mousedown="handleDragStart" @touchstart="handleDragStart" :class="{ 'is-dragging': isDragging }">
    <div class="voice-image-body">
      <div class="voice-image-container">
        <img draggable="false" :src="getImgUrl" alt="">
      </div>
      <div class="voice-image-tips">
        <span class="voice-tips">
          {{ voiceTips }}
        </span>
      </div>
      <div class="voice-image-name">
        <span class="voice-name" v-if="!isRecording">语音助手</span>
        <img v-else draggable="false" src="https://bigdata.topeti.com/wechatRepository/image/voice-ripple.gif" alt="">
      </div>
    </div>
    <div class="voice-subtitles" v-if="currentTranscription">
      <div class="voice-subtitles-conatiner">
        <span>{{ currentTranscription }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: 'voiceImage',
  // 组件参数 接收来自父组件的数据
  props: {
    isRecording: {
      type: Boolean,
      default: false
    },
    isTodoBtn: {
      type: Boolean,
      default: false
    },
    ws: {},
    styleTemp: {
      type: Object,
      default: ()=> ({})
    },
    currentTranscription: {
      type: String,
      default: ''
    }
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data () {
    return {
      isDragging: false,
      dragOffsetX: 0,
      dragOffsetY: 0,

      // 容器定位，用于存储拖拽后的位置
      positionStyle: {
        // 初始定位到右下角
        bottom: '32px', // 距离底边缘 32px
        right: '64px',  // 距离右边缘 64px
        
        // 移除 top/left 的初始设置，使用 bottom/right 定位
        top: 'auto',    
        left: 'auto',   
        
        // 移除 transform 的初始居中效果，因为我们现在使用 bottom/right 准确定位
        transform: 'none',
      },
      hasMoved: false
    }
  },
  // 计算属性
  computed: {
    voiceTips() {
      if (this.isRecording) {
        return '正在聆听中...'
      } else if (this.isTodoBtn) {
        return '已收到，请稍后'
      } else if (!this.isRecording) {
        if (this.styleTemp.overAllStyle && this.styleTemp.overAllStyle.voiceInfo && this.styleTemp.overAllStyle.voiceInfo) {
          const info = this.styleTemp.overAllStyle.voiceInfo.avatarConfig
          if (info) {
            return info.searchVal
          }
        }
        return '我是AI助理，需要什么帮忙？'
      } else {
        return ''
      }
    },
    getImgUrl() {
      let defaultUrl = 'https://bigdata.topeti.com/PCRepository/mainPlatform/chat/s-enterprise-0.png'
      if (this.styleTemp.overAllStyle && this.styleTemp.overAllStyle.voiceInfo && this.styleTemp.overAllStyle.voiceInfo) {
        const info = this.styleTemp.overAllStyle.voiceInfo
        if (info.avatarConfig && info.avatarConfig.avatarId) {
          return `https://bigdata.topeti.com/PCRepository/mainPlatform/chat/s-${info.avatarConfig.avatarId}.png`
        } else if (info.avatarConfig && info.avatarConfig.halfBodyImage) {
          return this.$imgurl + '/userfiles/' + info.avatarConfig.halfBodyImage
        } else {
          return defaultUrl
        }
      }
      return defaultUrl
    }
  },
  // 侦听器
  watch: {
    hasMoved: {
      handler(newVal) {
        this.$emit('hasMoved', newVal)
      },
      immediate: true
    }
  },
  beforeUnmount() {
    document.removeEventListener('mousemove', this.handleDragMove);
    document.removeEventListener('mouseup', this.handleDragEnd);
    document.removeEventListener('touchmove', this.handleDragMove);
    document.removeEventListener('touchend', this.handleDragEnd);
  },
  // 组件方法
  methods: {
    handleDragStart(e) {
      // 阻止默认的拖拽行为
      // e.preventDefault();

      // 兼容处理：获取鼠标或触摸点
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;

      this.isDragging = true;
      // 获取元素相对于视口的位置
      const rect = this.$el.getBoundingClientRect();

      // 计算鼠标/触摸点与元素左上角的偏移量
      this.dragOffsetX = clientX - rect.left;
      this.dragOffsetY = clientY - rect.top;

      // 在拖拽开始时，取消CSS的transform居中效果，改为用 top/left 精确控制
      this.positionStyle.transform = 'none';

      // 监听全局移动和释放事件
      document.addEventListener('mousemove', this.handleDragMove);
      document.addEventListener('mouseup', this.handleDragEnd);
      document.addEventListener('touchmove', this.handleDragMove);
      document.addEventListener('touchend', this.handleDragEnd);
    },

    handleDragMove(e) {
      if (!this.isDragging) return;

      // 兼容处理：获取鼠标或触摸点
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;

      // 计算新的 top 和 left 值
      let newX = clientX - this.dragOffsetX;
      let newY = clientY - this.dragOffsetY;
      this.hasMoved = true;
      // 更新 positionStyle
      this.positionStyle.left = `${newX}px`;
      this.positionStyle.top = `${newY}px`;
    },

    handleDragEnd() {
      this.isDragging = false;

      // 移除全局监听器
      document.removeEventListener('mousemove', this.handleDragMove);
      document.removeEventListener('mouseup', this.handleDragEnd);
      document.removeEventListener('touchmove', this.handleDragMove);
      document.removeEventListener('touchend', this.handleDragEnd);
      this.$nextTick(() => {
        // 在点击事件触发后（通常在 mouseup 之后很快），重置 hasMoved 
        // 如果点击事件被下面的 toggleRecording 阻止，这里也会被重置
        setTimeout(() => {
            this.hasMoved = false;
        }, 200); // 给浏览器足够的时间处理 click 事件，然后再清理状态
      });
    },
  }
}
</script>

<style scoped lang="scss">
.voice-image {
  width: 120px;
  height: 120px;
  position: fixed;
  right: 64px;
  bottom: 32px;
  z-index: 99999;
  &-body {
    cursor: pointer;
    width: 100%;
    height: 120px;
    background: url('https://bigdata.topeti.com/wechatRepository/image/voice-bg.png') no-repeat;
    padding: 10px;
    box-sizing: border-box;
    background-size: contain;
    position: relative;
  }
  &-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    img {
      width: 65px;
      margin-left: 15px;
      margin-top: 10px;
      user-select: none;
      /* 兼容性前缀（虽然现代浏览器通常不需要，但为了安全可添加） */
      -webkit-user-drag: none; /* 针对旧版 Safari/Chrome */
      -moz-user-select: none;  /* 针对 Firefox */
      -ms-user-select: none;   /* 针对旧版 IE/Edge */
    }
  }
  &-tips {
    height: 40px;
    background: url('https://bigdata.topeti.com/wechatRepository/image/voice-tips.png') no-repeat;
    width: 206px;
    background-size: cover;
    position: absolute;
    top: -10px;
    left: -50%;
    text-align: center;
    padding-top: 6px;
    box-sizing: border-box;
    .voice-tips {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #FBFBFD;
      font-weight: 400;
      font-size: 12px;
      user-select: none;
    }
  }
  &-name {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background-size: contain;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 47px;
      position: relative;
      bottom: -8px;
      user-select: none;
      /* 兼容性前缀（虽然现代浏览器通常不需要，但为了安全可添加） */
      -webkit-user-drag: none; /* 针对旧版 Safari/Chrome */
      -moz-user-select: none;  /* 针对 Firefox */
      -ms-user-select: none;   /* 针对旧版 IE/Edge */
    }
    .voice-name {
      color: transparent;
      font-weight: 400;
      font-size: 20px;
      font-style: normal;
      text-decoration: none;
      background: linear-gradient(90deg, rgba(154, 105, 252, 1) 0%, rgba(85, 112, 248, 1) 100%);
      background-clip: text;
    }
  }
  .voice-subtitles {
    width: 250px;
    box-shadow:  0 0 0 2px rgba(135, 206, 250, 0.8), /* 浅蓝色内部边线 */ 0 0 10px rgba(147, 112, 219, 0.4), /* 淡紫色发光 */ 0 0 20px rgba(0, 191, 255, 0.3); /* 淡蓝色发光 */
    left: -70%;
    box-sizing: border-box;
    position: relative;
    border-radius: 10px;
    background: #e6e9f0;
    &-conatiner {
      border-radius: 10px;
      padding: 20px;
      backdrop-filter: blur(2px); 
      background-color: rgba(255, 255, 255, 0.2);
      height: 100%;
      width: 100%;
      box-sizing: border-box;
    }
    span {
      color: #000000;
      font-weight: 400;
      font-size: 16px;
      white-space: wrap;
    }
  }
}
</style>
